import * as actions from "../actions/Type";
const intialState = {
  create_project: {},
  list_projects: [],
  project_view_bills: {},
  list_all_projects: [],
  all_sell_property: [],
  all_rent_property: [],
  view_projects: {},
  view_each_shuqa: {},
  create_vella_project: {},
  view_list_vella_project: [],
  list_all_bills_projects: [],
  list_selects_Data: [],
  list_selects_Data_obj: {},
  view_rents: {},
  calculate_transaction: {},
  // loading
  S_L_status: false,
  R_L_status: false,
  project_status: false,
};
const ProjectReducer = (state = intialState, action) => {
  switch (action.type) {
    case actions.VIEW_ALL_SELL:
      return {
        ...state,
        view_sels: action.payload,
      };
    case actions.VIEW_ALL_RENT:
      return {
        ...state,
        view_rents: action.payload,
      };
    case actions.PROJECT_CREATED:
      return {
        ...state,
        create_project: action.payload,
      };
    case actions.PROJECT_CREATED:
      return {
        ...state,
        create_vella_project: action.payload,
      };
    case actions.GET_LIST_PROJECTS:
      return {
        ...state,
        list_projects: action.payload,
      };
    case actions.GET_PROJECTS:
      return {
        ...state,
        list_all_projects: action.payload,
        project_status: action.project_status,
      };
    case actions.GET_ALL_RENT_PROPERTY:
      return {
        ...state,
        all_rent_property: action.payload,
        R_L_status: action.R_L_status,
      };
    case actions.GET_ALL_SELL_PROPERTY:
      return {
        ...state,
        all_sell_property: action.payload,
        S_L_status: action.S_L_status,
      };
    case actions.VIEW_PROJECTS:
      return {
        ...state,
        view_projects: action.payload,
      };
    case actions.COUNT_SHUQA_BYSTATUS:
      return {
        ...state,
        count_shuqa: action.payload,
      };
    case actions.UPDATE_SHUQA:
      return {
        ...state,
      };
    case actions.UPDATE_VELLA:
      return {
        ...state,
      };
    case actions.DELETE_SHUQA:
      return {
        ...state,
      };
    case actions.VIEW_DETAIL_EACH_SHUQA:
      return {
        ...state,
        view_each_shuqa: action.payload,
      };
    case actions.VIEW_VELLA_PROJECTS:
      return {
        ...state,
        view_list_vella_project: action.payload,
      };
    case actions.DELETE_VELLA:
      return {
        ...state,
      };
    case actions.DELETE_PROJECT:
      return {
        ...state,
      };
    case actions.DELETE_TAED:
      return {
        ...state,
      };
    case actions.CANCEL_BILL_PROJECT:
      return {
        ...state,
      };
    case actions.UPDATE_PROJECT:
      return {
        ...state,
      };
    case actions.GET_BILLS_PROJECTS:
      return {
        ...state,
        list_all_bills_projects: action.payload,
      };
    case actions.POST_SELECTS_BILLS:
      return {
        ...state,
        list_selects_Data: action.payload,
        list_selects_Data_obj: action.payload[0],
      };
    case actions.VELLAS_CREATED:
      return {
        ...state,
        view_list_vella_project: [
          ...state.view_list_vella_project,
          ...action.payload,
        ],
      };
    case actions.RATIO_EXP_REALESTATE:
      return {
        ...state,
        calculate_transaction: action.payload,
      };
    case actions.VIEW_PROJECT_BILLS:
      return {
        ...state,
        project_view_bills: action.payload,
        index: action.obj,
      };
    default:
      return { ...state };
  }
};

export default ProjectReducer;
